import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
} from "@mui/material";

function PreventiveCareCompletionDialog({
  open,
  item,
  formData,
  onChange,
  onCancel,
  onSubmit,
}) {
  const handleFieldChange = (name, value) => {
    onChange({
      ...formData,
      [name]: value,
    });
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Complete preventive care item</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            label="Completion Date"
            type="date"
            fullWidth
            margin="normal"
            value={formData.completion_date}
            onChange={(e) => handleFieldChange("completion_date", e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            label="Notes"
            fullWidth
            multiline
            rows={4}
            margin="normal"
            value={formData.notes}
            onChange={(e) => handleFieldChange("notes", e.target.value)}
            placeholder="Add any relevant notes about this completion..."
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onSubmit} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

PreventiveCareCompletionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  item: PropTypes.object,
  formData: PropTypes.shape({
    completion_date: PropTypes.string,
    notes: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

PreventiveCareCompletionDialog.defaultProps = {
  item: null,
};

export default PreventiveCareCompletionDialog;
